import pond from "../../http/requests/pond";

export default {
	addPond({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				pond.createPond(payload)
					.then(response => {
						if (response.data && response.data.error_code !== 0) {
							console.log("[ADD_POND] throw");
							throw response.data.error_message;
						} else {
							console.log("[ADD_POND]", response.data.data.pond);
							commit("ADD_POND", response.data.data.pond);
							resolve(response);
						}
					})
					.catch(error => {
						reject(error);
					});
			});
		} catch (error) {
			console.error("[addPond]", error);
		}
	},
	updatePond({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				pond.updatePond(payload.id, payload.data)
					.then(response => {
						if (response.data && response.data.error_code !== 0) {
							console.log("[UPDATE_POND] throw");
							throw response.data.error_message;
						} else {
							console.log("[UPDATE_POND]", response.data.data.pond);
							commit("UPDATE_POND", response.data);
							resolve(response);
						}
					})
					.catch(error => {
						reject(error);
					});
			});
		} catch (error) {
			console.error("[updatePond]", error);
		}
	},
	updateDaily({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				pond.updateDaily(payload.id, payload.data)
					.then(response => {
						if (response.data && response.data.error_code !== 0) {
							console.log("[UPDATE_POND] throw");
							throw response.data.error_message;
						} else {
							resolve(response);
						}
					})
					.catch(error => {
						reject(error);
					});
			});
		} catch (error) {
			console.error("[updatePond]", error);
		}
	},
	assignPond({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				pond.assignPond(payload)
					.then(response => {
						if (response.data && response.data.error_code !== 0) {
							throw response.data.error_message;
						} else {
							// commit("ASSIGN_POND", response.data);
							resolve(response);
						}
					})
					.catch(error => {
						reject(error);
					});
			});
		} catch (error) {
			console.error("[updatePond]", error);
		}
	},
	fetchPonds({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				pond.getListPonds(payload)
					.then(response => {
						commit("SET_PONDS", response.data.data.ponds);
						commit("SET_TOTAL_PONDS", response.data.data.total);
						resolve(response.data.data.ponds);
					})
					.catch(error => {
						reject(error);
					});
			});
		} catch (error) {
			console.error("[fetchPonds]", error);
		}
	},
	fetchPond({ commit }, userId) {
		try {
			return new Promise((resolve, reject) => {
				pond.getPond(userId)
					.then(response => {
						if (response.data && response.data.error_code !== 0) {
							console.log("[getPond] throw");
							reject(response.data.error_message);
							throw response.data.error_message;
						} else {
							console.log("[getPond]", response.data.pond);
							commit("UPDATE_POND", response.data.pond);
							resolve(response.data.pond);
						}
					})
					.catch(error => {
						reject(error);
					});
			});
		} catch (error) {
			console.error("[fetchPond]", error);
		}
	},
	fetchYield({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				pond.getYield(payload)
					.then(response => {
						if (response.data && response.data.error_code !== 0) {
							console.log("[fetchYield] throw");
							reject(response.data.error_message);
							throw response.data.error_message;
						} else {
							resolve(response.data);
						}
					})
					.catch(error => {
						reject(error);
					});
			});
		} catch (error) {
			console.error("[fetchPond]", error);
		}
	},
	removeRecord({ commit }, userId) {
		try {
			return new Promise((resolve, reject) => {
				pond.deletePond(userId)
					.then(response => {
						if (response.data && response.data.error_code !== 0) {
							console.log("[deletePond] throw");
							reject(response.data.error_message);
							throw response.data.error_message;
						} else {
							commit("REMOVE_RECORD", userId);
							resolve(response.data);
						}
					})
					.catch(error => {
						reject(error);
					});
			});
		} catch (error) {
			console.error("[deletePond]", error);
		}
	},
	setListPonds({ commit }, ponds) {
		commit("SET_PONDS", ponds);
	}
};
